import {
  isPluginVersionAtLeast,
  parsePluginVersion,
} from '@/lib/host-bridge/plugin-version';

const DEFAULT_MIN_SCREENSHOT_PLUGIN_VERSION = '1.1.0';
const DEFAULT_RECOMMENDED_PLUGIN_VERSION = '2.0.0';

/**
 * Minimum Revit plugin version used by screenshot and artifact export
 * tooling. Override via NEXT_PUBLIC_REVIT_PLUGIN_MIN_VERSION (x.y.z or
 * x.y.z.w).
 */
export function getMinScreenshotPluginVersion(): string {
  const configured = process.env.NEXT_PUBLIC_REVIT_PLUGIN_MIN_VERSION?.trim();
  if (configured && parsePluginVersion(configured)) {
    return configured;
  }

  return DEFAULT_MIN_SCREENSHOT_PLUGIN_VERSION;
}

export const MIN_SCREENSHOT_PLUGIN_VERSION = getMinScreenshotPluginVersion();

/**
 * Recommended Revit plugin version shown by release/update nudges.
 * This can be newer than feature-specific minimums so older compatible
 * plugins keep working while users are asked to upgrade to the latest
 * release.
 */
export function getRecommendedPluginVersion(): string {
  const configured =
    process.env.NEXT_PUBLIC_REVIT_PLUGIN_RECOMMENDED_VERSION?.trim();
  if (configured && parsePluginVersion(configured)) {
    return configured;
  }

  return DEFAULT_RECOMMENDED_PLUGIN_VERSION;
}

export const RECOMMENDED_PLUGIN_VERSION = getRecommendedPluginVersion();

export function supportsRevitScreenshot(
  pluginVersion: string | null | undefined,
): boolean {
  return isPluginVersionAtLeast(pluginVersion, MIN_SCREENSHOT_PLUGIN_VERSION);
}
